import { createContext, useContext, useMemo } from 'react';
import { useSubscribeOnMount } from "../hooks/useSubscribeOnMount";
import { jsx as _jsx } from "react/jsx-runtime";
export let InvoiceOptimisticUpdateType = /*#__PURE__*/function (InvoiceOptimisticUpdateType) {
  InvoiceOptimisticUpdateType["Refunded"] = "refunded";
  InvoiceOptimisticUpdateType["RefundRequested"] = "refundRequested";
  InvoiceOptimisticUpdateType["Voided"] = "voided";
  InvoiceOptimisticUpdateType["PaymentApproved"] = "paymentApproved";
  InvoiceOptimisticUpdateType["PaymentConfirmed"] = "paymentConfirmed";
  InvoiceOptimisticUpdateType["QboIntegrationChanged"] = "qboIntegrationChanged";
  InvoiceOptimisticUpdateType["XeroIntegrationChanged"] = "xeroIntegrationChanged";
  InvoiceOptimisticUpdateType["PartialRefundRequested"] = "partialRefundRequested";
  InvoiceOptimisticUpdateType["PartiallyRefunded"] = "partiallyRefunded";
  return InvoiceOptimisticUpdateType;
}({});
const InvoiceChangesObservableContext = /*#__PURE__*/createContext({
  subscribe: () => {},
  unsubscribe: () => {},
  notify: async () => {}
});
export function InvoiceChangesObservableProvider(_ref) {
  let {
    children,
    observable
  } = _ref;
  const value = useMemo(() => ({
    subscribe: subscriber => observable.subscribe(subscriber),
    unsubscribe: id => observable.unsubscribe(id),
    notify: options => observable.notify(options)
  }), [observable]);
  return /*#__PURE__*/_jsx(InvoiceChangesObservableContext.Provider, {
    value: value,
    children: children
  });
}
export function useInvoiceChangesObservable() {
  return useContext(InvoiceChangesObservableContext);
}
export function useSubscribeToInvoiceChangesObservable(callback) {
  const actions = useContext(InvoiceChangesObservableContext);
  useSubscribeOnMount(actions, callback);
}